import React from 'react';
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';

const ExperienceSection = styled.section`
  padding: 5.5rem 1.6rem 4.5rem;
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
  text-align: left;
`;

const Title = styled.h1`
  font-size: 2.7rem;
  margin-bottom: 0.6rem;
  letter-spacing: -0.03em;
`;

const SubText = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.textSecondary || '#888'};
  max-width: 700px;
  margin: 0 0 2.5rem;
  line-height: 1.6;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
  justify-content: center;
`;

const Card = styled.div`
  background-color: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  padding: 2rem;
  border-radius: 0;
  border: 1px solid ${({ theme }) => theme.line || 'rgba(12,12,12,0.12)'};
  text-align: left;

  h3 {
    font-size: 1.3rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.text};

    span {
      font-weight: normal;
      color: ${({ theme }) => theme.textSecondary || '#aaa'};
      font-size: 0.95rem;
    }
  }

  ul {
    list-style: none;
    padding-left: 0;

    li {
      margin-bottom: 1rem;
      font-size: 1rem;
      line-height: 1.5;
      color: ${({ theme }) => theme.text};

      strong {
        color: ${({ theme }) => theme.text};
      }
    }

    a {
      color: ${({ theme }) => theme.text};
      font-weight: 500;
      text-decoration: underline;
      transition: color 0.2s ease;

      &:hover {
        color: #005fa3;
        text-decoration: none;
      }
    }
  }
`;

function Experience() {
  return (
    <ExperienceSection id="experience">
      <Title>Experience</Title>
      <SubText />

      <CardGrid>
        <Card>
          <h3>Frontend Developer <span>(2023–Present)</span></h3>
          <ul>
            <li>Built real projects with HTML, CSS, JavaScript, React, and Redux</li>
            <li>Created responsive layouts with clean UI patterns and proper accessibility</li>
            <li>Used Git and structured code for maintainability</li>
            <li>Implemented reusable components and consistent UI structure for maintainable codebases</li>
          </ul>
        </Card>

       <Card>
  <h3>Client & Personal Projects — Web Applications & Portfolio Sites <span>(2024–2025)</span></h3>
  <ul>
    <li>
      Built a Qatar Airways–inspired airline dashboard using React, Vite, Emotion, and Recharts — with rotating datasets, a theme system, and fully responsive grid layout
    </li>
    <li>
      Designed data flows, component communication, and API-style data loading for dashboard interactions
    </li>
    <li>
      Designed and launched custom portfolio websites for a film composer and a classical guitar tutor, including YouTube, SoundCloud, and image gallery integrations
    </li>
    <li>
      Delivered each project end-to-end — planning, building, refining, and deploying with client feedback
    </li>
  </ul>
</Card>


        <Card>
          <h3>Professional Development</h3>
          <ul>
            <li> <a href="https://www.freecodecamp.org/certification/lukast605n/responsive-web-design" target="_blank" rel="noreferrer">FreeCodeCamp — Responsive Web Design Certification</a></li>
            <li> Codecademy Frontend Career Path — <strong>Completed July 2025</strong></li>
            <li> Continuing to expand skills through practice, study, and portfolio projects</li>
            <li>Currently learning backend fundamentals and Android basics for system-level projects</li>
          </ul>
        </Card>
      </CardGrid>
    </ExperienceSection>
  );
}


export default Experience;
